import { useState, useEffect } from 'react';

/**
 * 크롬 확장프로그램(셀러박스 모니터링 에이전트) 설치 여부를 감지하는 훅
 *
 * 확장프로그램이 설치되면 document.documentElement에
 * data-sellerbox-extension="true" 속성이 삽입됨 (SB-5846 스펙)
 *
 * run_at: document_idle 이므로 비동기 감지 필요
 */
const useExtensionInstalled = () => {
  const [isExtensionInstalled, setIsExtensionInstalled] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    // 즉시 체크
    const checkNow = () => {
      return document.documentElement.dataset.sellerboxExtension === 'true';
    };

    if (checkNow()) {
      setIsExtensionInstalled(true);
      setIsChecking(false);
      return;
    }

    // document_idle 타이밍 고려하여 지연 체크
    const timer = setTimeout(() => {
      if (checkNow()) {
        setIsExtensionInstalled(true);
      }
      setIsChecking(false);
    }, 1000);

    // MutationObserver로 속성 변경 감지 (타이머 전에 삽입될 수 있음)
    const observer = new MutationObserver(() => {
      if (checkNow()) {
        setIsExtensionInstalled(true);
        setIsChecking(false);
        observer.disconnect();
        clearTimeout(timer);
      }
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-sellerbox-extension'],
    });

    return () => {
      clearTimeout(timer);
      observer.disconnect();
    };
  }, []);

  return { isExtensionInstalled, isChecking };
};

export default useExtensionInstalled;
